import React from 'react';

/* This function will replace every \n and \r with <br/> tags so they are translated to visual line breaks */

const insertBr = text => {
  if (!text) return '';
  // Let's split the string along new line characters
  const textParts = text.split(/[\n\r]/);

  // Insert the <br/> tags
  const elementsWithBr = textParts
    .reduce((reactElements, textPart, index) => {
      // eslint-disable-next-line react/no-array-index-key
      return [...reactElements, textPart, <br key={index} />];
    }, [])
    .filter(el => el);

  // Remove line breaks at the beginning and end
  const startIndexToSliceAt = elementsWithBr
    .slice()
    .findIndex(element => !React.isValidElement(element));
  const endIndexToSliceAt = elementsWithBr
    .slice()
    .reverse()
    .findIndex(element => !React.isValidElement(element));
  return elementsWithBr.slice(startIndexToSliceAt, -endIndexToSliceAt);
};

export default insertBr;
